import { render, staticRenderFns } from "./knowledgeBaseFileList.vue?vue&type=template&id=79484b6e"
import script from "./knowledgeBaseFileList.vue?vue&type=script&lang=js"
export * from "./knowledgeBaseFileList.vue?vue&type=script&lang=js"
import style0 from "./knowledgeBaseFileList.vue?vue&type=style&index=0&id=79484b6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports